export const usaStateNameMap: { [abbr: string]: string } = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'Washington D.C.',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const cadProvinceNameMap: { [abbr: string]: string } = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NT: 'Northwest Territories',
  NS: 'Nova Scotia',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
};

// https://metropolisio.atlassian.net/browse/EN-5592
export const usaStateEquivalentToNameMap: { [name: string]: string } = {
  D: 'Diplomat',
  G: 'Government',
  ML: 'Military',
};

// this can be optimized by putting these data in backend
// so the API response comes back with abbrev and full names
export const abbreviationToNameMap: { [abbr: string]: string } = {
  USA: 'USA',
  ...usaStateNameMap,
  OTHER: 'Other',
  CAN: 'CAN',
  ...cadProvinceNameMap,
  ...usaStateEquivalentToNameMap,
};

// creates label given a state abbreviation
// label is usually `Full name (ABBR)` e.g. California (CA)
// exceptions for non USA states and CAD provinces / territories
export function plateAbbreviationToLabel(abbr: string) {
  if (usaStateEquivalentToNameMap[abbr]) {
    return usaStateEquivalentToNameMap[abbr];
  }

  const usaOrCad = cadProvinceNameMap[abbr] || usaStateNameMap[abbr];
  if (usaOrCad) {
    return `${usaOrCad} (${abbr})`;
  }

  // fallback
  return abbr;
}
